import { IPrivateEndpointMetadata } from './private-endpoint-metadata';
import { getReadonlyControl, getCosmosDBControl, cosmosResourceIdFormat, cosmosResourceIdErrorMessage } from './shared-control-metadata';

import { adfModelTypeMap } from '../consts/adf-model-type-map-const';

export const azureCosmosDBPrivateEndpointMetadata: IPrivateEndpointMetadata = {
    resourceType: 'Microsoft.DocumentDb/databaseAccounts',
    connectionSuffix: 'privateEndpoints',
    resourceIdValidator: cosmosResourceIdFormat,
    groupIdMetadata: {
        Analytical: {
            linkedServiceType: adfModelTypeMap.cosmosMongo.linkedServiceType,
            groupId: 'Analytical',
            groupIdFamily: 'cosmosDbMongo',
            iconClass: 'svg-i-100x100-AzureCosmosDB',
            disablePublish: true,
            displayName: stringResources.CosmosDbMongoApi_DisplayText
        },
        MongoDB: {
            linkedServiceType: adfModelTypeMap.cosmosMongo.linkedServiceType,
            groupId: 'MongoDB',
            groupIdFamily: 'cosmosDbMongo',
            iconClass: 'svg-i-100x100-AzureCosmosDB',
            displayName: stringResources.CosmosDbMongoApi_DisplayText,
            // Remove once feature flag is removed.
            controls: {
                creationControls: getCosmosDBControl(true),
                readonlyControls: getReadonlyControl(cosmosResourceIdFormat, cosmosResourceIdErrorMessage)
            }
        },
        Sql: {
            linkedServiceType: adfModelTypeMap.cosmosSql.linkedServiceType,
            groupId: 'Sql',
            groupIdFamily: 'cosmosDbSql',
            iconClass: 'svg-i-100x100-AzureCosmosDB',
            displayName: stringResources.CosmosDb_DisplayText,
            // Remove once feature flag is removed.
            controls: {
                creationControls: getCosmosDBControl(false, undefined),
                readonlyControls: getReadonlyControl(cosmosResourceIdFormat, cosmosResourceIdErrorMessage)
            }
        }
    },
    groupIdFamilyMetadata: {
        cosmosDbMongo: {
            linkedServiceType: adfModelTypeMap.cosmosMongo.linkedServiceType,
            displayName: stringResources.CosmosDbMongoApi_DisplayText,
            iconClass: 'svg-i-100x100-AzureCosmosDB',
            controls: {
                creationControls: getCosmosDBControl(true, ['Analytical', 'MongoDB']),
                readonlyControls: getReadonlyControl(cosmosResourceIdFormat, cosmosResourceIdErrorMessage)
            }
        },
        cosmosDbSql: {
            linkedServiceType: adfModelTypeMap.cosmosSql.linkedServiceType,
            displayName: stringResources.CosmosDb_DisplayText,
            iconClass: 'svg-i-100x100-AzureCosmosDB',
            controls: {
                creationControls: getCosmosDBControl(false, ['Analytical', 'Sql']),
                readonlyControls: getReadonlyControl(cosmosResourceIdFormat, cosmosResourceIdErrorMessage)
            }
        }
    }
};
